import { GET_API } from "../../Functionalities/APIs";
import { basisParam } from "../../Functionalities/dayBasis";
import { rupees as rupeesText } from "../Insights/format";
import { ManageDeliveryBoyWallet } from "./Logic";

const RIDER_ORDERS_URL = "/accounts/settlement/riders/orders/";
export const PAGE_SIZE = 25;

export const walletQuery = (riderId, range, basis) =>
  `delivery_boy_id=${riderId}&is_transaction_query=true` +
  (range ? `&from_date=${range.from} 00:00:00&to_date=${range.to} 00:00:00` : "") +
  basisParam(basis);

export const ordersQuery = (riderId, range, basis, page) =>
  `rider_id=${riderId}&limit=${PAGE_SIZE}&offset=${(page - 1) * PAGE_SIZE}` +
  (range ? `&from=${range.from}&to=${range.to}` : "") +
  basisParam(basis);

export const walletFigures = ({ balance_to_get: get, balance_to_pay: pay }) => ({
  collected: get.collected,
  handedIn: get.submited,
  toGet: get.balance,
  earned: pay.delivery_charge,
  paid: pay.paid_delivery_charge,
  toPay: pay.balance,
});

export const pageLabel = (page, count) =>
  count ? `${(page - 1) * PAGE_SIZE + 1}–${Math.min(page * PAGE_SIZE, count)} of ${count} orders` : "No orders";

export const fetchWallet = async (riderId, range, basis) => {
  const result = await ManageDeliveryBoyWallet("", "", "get", walletQuery(riderId, range, basis));
  return result && result.data && result.data.balance_to_get ? walletFigures(result.data) : null;
};

export const fetchRiderOrders = async (riderId, range, basis, page) => {
  const result = await GET_API("", ordersQuery(riderId, range, basis, page), RIDER_ORDERS_URL);
  const body = result && result.data;
  return body && body.Status === true ? { count: body.count, rows: body.results } : { count: 0, rows: [] };
};

const STATEMENTS_URL = "/accounts/salary/";
export const STATEMENT_LIMIT = 200;

export const statementsQuery = (riderId, range) =>
  `rider_id=${riderId}&limit=${STATEMENT_LIMIT}` + (range ? `&from=${range.from}&to=${range.to}` : "");

export const fetchStatements = async (riderId, range) => {
  const result = await GET_API("", statementsQuery(riderId, range), STATEMENTS_URL);
  const body = result && result.data;
  return body && body.Status === true ? { rows: body.results, summary: body.summary } : { rows: [], summary: null };
};

export const standingLine = (summary) => {
  if (!summary) return "";
  if (summary.owe_to_franchise > 0) return `Owes the office ${rupeesText(summary.owe_to_franchise)} now`;
  if (summary.franchise_owes > 0) return `The office owes ${rupeesText(summary.franchise_owes)} now`;
  return "Nothing owed either way now";
};
